const initialState = {
  firebaseToken: null,
  selectedService: null,
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_FIREBASE_TOKEN":
      return {
        ...state,
        ...action.payload,
      };
    case "SET_SELECTED_SERVICE":
      return {
        ...state,
        selectedService: action?.payload?.data,
      };
    default:
      return state;
  }
};

export default accountReducer;
